// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29xpi","toggle":"styles_toggle__1_M-l","preview":"styles_preview__2KOWR"};